<template>
  <div class="fastPaymentOrder">
    <!-- 列表 -->
    <div class="list">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="min-height:100%">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getList"
            >
            <div class="item" v-for="(item,index) in list" :key="index" @click="toggleCheck(index)">
                <div class="item_1">
                    <div class="item_title">
                      <span>
                        {{item.buyer_name}}
                      </span>
                      <span>
                        ￥{{item.debts}}
                      </span>
                    </div>
                    <div class="item_des">
                      订单编号：{{item.order_sn}}
                    </div>
                    <div class="item_des van-ellipsis">
                      菜品名：
                      <span v-if="item.goods.length>0">
                        <span v-for="(item_good,index_good) in item.goods" :key="index_good">{{index_good>0?'、':''}}{{item_good.name}}</span>
                      </span>
                      <span v-else>无</span>
                    </div>
                    <div class="item_des item_date">
                      赊欠时间：{{item.credit_time | toTime}}
                    </div>
                </div>
                <div class="item_2">
                  <van-checkbox v-model="item.checkbox" checked-color="#31B158" ref="checkboxes"></van-checkbox>
                </div>
            </div>
            <div style="height:0.5rem"></div>
            </van-list>
        </van-pull-refresh>
    </div>
    <!-- 底部结算栏 -->
    <div style="height:1.4rem"></div>
    <div class="order_footer" :disabled="subData.order_num == 0">
      <div>
        <span>总计：<span class="color_theme"> ￥{{(Number (subData.order_mount)).toFixed(2)}}</span></span>
        <span>已选：<span class="color_theme">{{subData.order_num}}</span> 笔</span>
      </div>
      <div class="" @click="toPayment">
        还款
      </div>
    </div>
  </div>
</template>

<script>
import { credit_order_list } from "@/api/work/credit/credit"
import { timestampToTime } from "@/utils/timestamp"
export default {
  name: 'fastPaymentOrder',
  filters:{
    toTime(t){
      return timestampToTime(t)
    }
  },
  data(){
    return {
      actions: [
        { name: '选择订单还款' },
        { name: '直接还款', subname: '不选择订单，按欠款总金额还款' },
      ],
      list: [],
      loading: true,
      finished: true,
      refreshing: false,
      listQuery:{
        buyer_id:''
      },
      item:{},


      actionSheetShow:false,

      subData:{
        order_id:[],
        order_num:0,
        order_mount:0.00,
      }
    }
  },
  created(){
    this.item = JSON.parse(decodeURI( this.$route.query.item ))
    this.listQuery.buyer_id = this.item.buyer_id
    this.getList()
    this.$navigation.on('back', (to, from) => {
      if(from.route.name == 'credit_payment'){
        this.getList()
        this.subData={
          order_id:[],
          order_num:0,
          order_mount:0.00,
        }
      }
    })
  },
  mounted(){




  },
  methods:{
    // 点击了搜索按钮
    onSearch(){
      this.$toast(this.listQuery.search)
    },

    // 去收款页面
    toPayment(){
      if(this.subData.order_num >0){
        this.$router.push({
          path: "/credit/payment",
          query:{
            subData:JSON.stringify(this.subData),
            item:encodeURI(JSON.stringify(this.item)),
            type:1
          }
        });
      }
    },

    
    // 获取列表
    getList(){
      credit_order_list(this.listQuery).then(res=>{
        if(res.code == 200 ){
            this.list = res.data
            this.finished = true;
            this.loading = false
            this.refreshing = false;
        }
      })
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.refreshing = true;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.getList();
    },

    // 切换选中状态
    toggleCheck(index) {
      this.list[index].checkbox = !this.list[index].checkbox
      this.count()
    },

    // 计算总额
    count(){
      this.subData.order_id=[]
      this.subData.order_num = 0
      this.subData.order_mount = 0.00
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if(item.checkbox){
          this.subData.order_num++
          this.subData.order_mount = Number (this.subData.order_mount) + Number(item.debts)
          this.subData.order_id.push(item.credit_id)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.fastPaymentOrder{
  position: relative;
  .list{
    position: relative;
    .item{
      margin: 0.2rem 0.3rem 0;
      border-radius: 0.1rem;
      background-color: #fff;
      // height: 1.3rem;
      box-sizing: border-box;
      padding:0.2rem 0.3rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.28rem;
      overflow: hidden;
      .item_1{
        width: 5.7rem;
        .item_title{
          font-size: 0.34rem;
          font-weight: 500;
          margin-bottom: 0.1rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          &>span:nth-child(2){
            color: #EF9B2F;
          }
        }
        .item_date{
          color: #999999;
          margin-top: 0.05rem;
        }
        .item_price{
          color:#EF9B2F;
        }
        .item_des{
          font-size: 0.28rem;
          color: #999;
          line-height: 0.36rem;
        }
      }
    }
  }
  
  // 底部
  .order_footer{
    width: 100%;
    height: 1.4rem;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0rem -0.1rem 0.2rem 0.05rem rgba(191, 191, 191, 0.1);
    &[disabled]{
      &>div:nth-child(1){
        &>span{
          color: #B3B3B3 !important;
          .color_theme{
            color: #B3B3B3 !important;
          }
        }
      }
      &>div:nth-child(2){
        background-color: #B3B3B3;
      }
    }
    &>div:nth-child(1){
      &>span{
        display: block;
        margin-left: 0.5rem;
        font-size: 0.36rem;
        color: #333;
        font-weight: bold;
        &:nth-child(2){
          margin-top: 0.1rem;
          font-size: 0.28rem;
        }
        .color_theme{
          color: #31b158;
          font-size: 0.36rem;
        }
      }
    }
    &>div:nth-child(2){
      width: 2.2rem;
      height: 1.4rem;
      background-color: #F3A427;
      color: #fff;
      font-size: 0.48rem;
      line-height: 1.4rem;
      text-align: center;
      font-weight: bold;
    }
  }
}
</style>

<style lang="less">
.fastPayment{
  .van-action-sheet__item{
    color: #31B158;
  }
}
</style>